import { FC } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import { Navigate } from "react-router-dom";
import { useRouteParams } from "app/route/route";
import {
    deleteReportVersionAccessInformationCredentialsRoute,
    reportVersionAccessInformationRoute,
} from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import {
    useDeleteReportAccessInformationCredentialsMutation,
    useReportAccessInformationCredentialsQuery,
} from "app/api/graph/types";
import { reportAccessInformationCredentialsGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { ConfirmDelete } from "app/component/form/ConfirmDelete";

export const DeleteReportVersionAccessInformationCredentialsScreen: FC = () => {
    const { reportId, versionId, credentialsId } = useRouteParams(deleteReportVersionAccessInformationCredentialsRoute);
    const { data, loading, error } = useReportAccessInformationCredentialsQuery({
        variables: { credentialsId: reportAccessInformationCredentialsGraphId(credentialsId) },
    });
    const [deleteCredentials, { data: deleteData, loading: deleting, error: deleteError }] =
        useDeleteReportAccessInformationCredentialsMutation({
            variables: { input: { id: reportAccessInformationCredentialsGraphId(credentialsId) } },
        });
    const credentials = data?.reportAccessInformationCredentials;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!credentials) {
        return <ErrorScreen title="Error" message="Not found." />;
    }
    if (deleteData?.deleteReportAccessInformationCredentials) {
        return <Navigate to={reportVersionAccessInformationRoute.build({ reportId, versionId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={deleteReportVersionAccessInformationCredentialsRoute} />
                <h1>{credentials.username}</h1>
                {deleteError ? <Alert variant="danger">{deleteError.message}</Alert> : null}
                <p>Are you sure that you want to permanently delete these credentials from this report version?</p>
                <ConfirmDelete onConfirm={() => deleteCredentials()} deleting={deleting} />
            </Container>
        </NavigationScreen>
    );
};
